<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">发布</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'title'
        label= '标题'>
      </el-table-column>
      <el-table-column
        prop= 'level'
        label= '等级'
        width= '100'>
        <template slot-scope='scope'>
          <el-button type='danger' size='small' v-if="scope.row.level===130">非常重要</el-button>
          <el-button type='warning' size='small' v-if="scope.row.level===120">重要</el-button>
          <el-button type='primary' size='small' v-if="scope.row.level===110">一般</el-button>
          <el-button type='success' size='small' v-if="scope.row.level===100">可忽略</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'scope'
        label= '影响范围'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.scope===10">地区级</el-button>
          <el-button type='primary' size='small' v-if="scope.row.scope===20">平台级 </el-button>
          <el-button type='warning' size='small' v-if="scope.row.scope===30">机构级</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'receiver'
        label= '接收方'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'startTime'
        label= '生效时效'
        width= '160'>
        <template slot-scope='scope'>
          {{ formatDate(scope.row.startTime) }}
        </template>
      </el-table-column>
      <el-table-column
        prop= 'endTime'
        label= '失效时效'
        width= '160'>
        <template slot-scope='scope'>
          {{ formatDate(scope.row.endTime) }}
        </template>
      </el-table-column>
      <el-table-column
        prop= 'status'
        label= '状态'
        width= '100'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.status===0">未审核</el-button>
          <el-button type='primary' size='small' v-if="scope.row.status===1">审核通过 </el-button>
          <el-button type='warning' size='small' v-if="scope.row.status===2">未通过</el-button>
          <el-button type='warning' size='small' v-if="scope.row.status===9">已发布</el-button>
        </template>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" width="960px">
      <el-form :model="form">
        <el-row>
          <el-col :span="13">
            <el-form-item label="标题" :label-width="formLabelWidth">
              <el-input v-model="form.title" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="内容" :label-width="formLabelWidth">
              <el-input v-model="form.content" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="等级" :label-width="formLabelWidth">
              <el-radio-group v-model="form.level" size="medium">
                <el-radio-button label=130>非常重要</el-radio-button>
                <el-radio-button label=120>重要</el-radio-button>
                <el-radio-button label=110>一般</el-radio-button>
                <el-radio-button label=100>可忽略</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="影响范围" :label-width="formLabelWidth">
              <el-radio-group v-model="form.scope" size="medium">
                <el-radio-button label=10>地区级</el-radio-button>
                <el-radio-button label=20>平台级</el-radio-button>
                <el-radio-button label=30>机构级</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="接收方" :label-width="formLabelWidth">
              <el-input v-model="form.receiver" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="生效时效" :label-width="formLabelWidth">
              <el-col :span="12">
                <el-date-picker type="datetime" placeholder="选择开始时间" v-model="form.startTime" style="width: 100%;"></el-date-picker>
              </el-col>
              <el-col :span="12">
                <el-date-picker type="datetime" placeholder="选择结束时间" v-model="form.endTime" style="width: 100%;"></el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="11" style="padding-left: 10px;">
            <quill-editor v-model="form.content" ref="myQuillEditor" :options="editorOption" style="height: 600px;"></quill-editor>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align: left;">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import { formatDate } from '../../../util/date'

import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  components: {
    quillEditor
  },
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        title: null,
        content: null,
        level: null,
        scope: null,
        source: null,
        receiver: null,
        startTime: null,
        endTime: null,
        status: null
      },
      formLabelWidth: '80px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      // 富文本编辑器配置
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
            ['blockquote', 'code-block'], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
            [{ script: 'sub' }, { script: 'super' }], // 上标/下标
            [{ indent: '-1' }, { indent: '+1' }], // 缩进
            [{ direction: 'rtl' }], // 文本方向
            [{ size: ['12', '14', '16', '18', '20', '22', '24', '28', '32', '36'] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            // [{ font: ['songti'] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ['clean'], // 清除文本格式
            ['image'] // 链接、图片、视频
          ]
        },
        placeholder: '请输入正文'
      }
    }
  },
  created () {
    this.query()
  },
  methods: {
    del (row) {
      let that = this
      console.log('del')
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/notice/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      console.log('delClose')
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/notice/listPage?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      let that = this
      this.form = {}
      requestService.get(`/notice/getOne?id=${row.id}`, that.form, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.form = res.data.body
        that.dialogFormVisible = true
      })
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm () {
      let that = this
      that.dialogFormVisible = false
      console.log('add')
      let url = '/notice/add'
      if (that.form.id) {
        url = '/notice/edit'
      }
      that.form.startTime = this.formatDate(that.form.startTime)
      that.form.endTime = this.formatDate(that.form.endTime)
      requestService.post(url, that.form, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/notice/Index.vue